import { Box, Button, Grid, Typography } from "@mui/material";
import { useState, useEffect, useRef } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import useGenerateOptions, {
  useGenerateArrayFromObj,
} from "../../../../../components/input/hook/useGenerateOptions2";
import ProductWithPriceInvoice, {
  ProductWithPriceInvoiceData,
} from "../../../../../components/product/ProductWithPrice-v2";
import { useGetSuppliers } from "../../../../supplier/api/supplier/resolver";
import { useGetPaymentMethods } from "../../../api/invoice/paymentMethod/resolver";
import { useGetPurchaseInvoiceConstants } from "../../../api/invoice/purchase/constant/resolver";
import Input from "../../../../../components/input/Input-v2";
import { M_InvoicePurchaseDetail } from "../../../type/Invoice.type";
import { NonEditableTableConfig } from "../../../tableConfig/TableConfig";
import { LoadingButton } from "../../../../../components/button/Button";
import { ModalFC } from "../../../../../components/modal/Modal";
import { useToast } from "../../../../../context/toast/ToastContext";
import { usePayPurchaseInvoice } from "../../../api/invoice/purchase/resolver";
import { MainContainerForm } from "../../../../../styles/Main.styles";

interface IForm {
  dataInvoice: M_InvoicePurchaseDetail;
}

export interface Form_Create_PurchaseInvoice {
  purchase_invoice_date: string;
  payment_method_id: string;
  purchase_invoice_status: string;
  product_list: string;
  supplier_id: string;
}

export interface Form_Update_PurchaseInvoice {
  purchase_invoice_id: string;
  payment_method_id: string;
}

export default function FormBelumLunas({ dataInvoice }: IForm) {
  const { show } = useToast();
  const refForm = useRef<any>();
  const [keyword, setKeyword] = useState<string>();
  const { control, setValue, handleSubmit, trigger, getValues } =
    useForm<Form_Create_PurchaseInvoice>();
  const { mutate: mutateUpdate, isLoading: loadingUpdate } =
    usePayPurchaseInvoice();
  const { data: dataRawPaymentMethod, isLoading: fetchPaymentMethod } =
    useGetPaymentMethods({});
  const dataPaymentMethod = dataRawPaymentMethod?.data.data.data;
  const { data: dataPaymentMethodOptions } = useGenerateOptions({
    dataSource: dataPaymentMethod,
    keyForText: "payment_method_name",
    keyForValue: "id",
  });
  const { data: dataRawInvoiceConstant, isLoading: fetchInvoiceConstant } =
    useGetPurchaseInvoiceConstants();
  const dataInvoiceConstant = dataRawInvoiceConstant?.data.data.status;
  const { data: dataStatusInvoice } = useGenerateArrayFromObj({
    dataSource: dataInvoiceConstant,
  });
  const { data: dataRawSuppliers, isLoading: fetchSuppliers } = useGetSuppliers(
    { keyword }
  );
  const dataSuppliers = dataRawSuppliers?.data.data.data;
  const { data: dataSupplierOptions } = useGenerateOptions({
    dataSource: dataSuppliers,
    keyForText: "supplier_name",
    keyForValue: "id",
  });
  const [showModal, setShowModal] = useState(false);
  const [cart, setCart] = useState<ProductWithPriceInvoiceData[]>([]);
  const { body, header, lastRow } = NonEditableTableConfig(
    dataInvoice.grand_total
  );

  useEffect(() => {
    setValue("payment_method_id", dataInvoice.payment_method_id);
    setValue("purchase_invoice_status", dataInvoice.status);
    setValue("supplier_id", dataInvoice.supplier_id);
    setCart(
      dataInvoice.purchase_invoice_detail.map((item) => {
        return {
          id: item.id,
          name: item.product.product_type_name,
          price: item.price,
          quantity: item.quantity,
          unitType: item.product.unit_type,
        };
      })
    );
  }, [dataInvoice]);

  const handleFormSubmit: SubmitHandler<Form_Create_PurchaseInvoice> = (
    data
  ) => {
    mutateUpdate({
      payment_method_id: data.payment_method_id,
      purchase_invoice_id: dataInvoice.id,
    });
  };

  const handleOpenPaymentConfimation = () => {
    const dataProductList = getValues("product_list");
    if (dataProductList.length <= 0) {
      show("Tidak ada barang yang dipilih", "warning");
      return;
    }
    if (getValues("payment_method_id") === null) {
      show("Mohon memilih pembayaran", "warning");
      return;
    }
    refForm.current.requestSubmit();
  };

  return (
    <form ref={refForm} onSubmit={handleSubmit(handleFormSubmit)}>
      <MainContainerForm mb={2}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Input.Controller
              control={control}
              name="purchase_invoice_status"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Select
                  showAsStatic
                  isFetching={fetchInvoiceConstant}
                  label="Status"
                  options={dataStatusInvoice}
                  value={field.value}
                  onChange={(e) => field.onChange(e.value)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="supplier_id"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Autocomplete
                  isFetching={fetchSuppliers}
                  label="Supplier"
                  options={dataSupplierOptions}
                  value={field.value}
                  onClick={(e) => field.onChange(e.value)}
                  onChange={(e) => setKeyword(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
        </Grid>
      </MainContainerForm>
      <MainContainerForm>
        <Grid item xs={12} md={12}>
          <Input.Controller
            control={control}
            name="product_list"
            render={(field) => (
              <ProductWithPriceInvoice
                body={body}
                header={header}
                lastRowRender={lastRow}
                onChange={(e) => field.onChange(e)}
                dataProduct={cart}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Box display={"flex"} justifyContent={"flex-end"} mt={2} gap={2}>
            <LoadingButton
              isLoading={false}
              text={"Bayar"}
              onClick={async () => {
                const isValid = await trigger([
                  "product_list",
                  "purchase_invoice_status",
                ]);
                if (isValid) {
                  setShowModal(true);
                }
              }}
            />
          </Box>
        </Grid>
      </MainContainerForm>
      <ModalFC open={showModal} onClose={() => setShowModal(false)}>
        <Box minHeight={150}>
          <Typography variant="h6" mb={1}>
            Apakah anda yakin ?
          </Typography>
          <Input.Controller
            control={control}
            name="payment_method_id"
            render={(field, fieldState) => (
              <Input.Select
                isFetching={fetchPaymentMethod}
                label="Metode Pembayaran"
                options={dataPaymentMethodOptions}
                value={field.value}
                onChange={(e) => field.onChange(e.value)}
                error={fieldState.error?.message}
              />
            )}
          />
          <Box display={"flex"} justifyContent={"flex-end"} mt={2} gap={2}>
            <Button variant="outlined" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <LoadingButton
              onClick={() => handleOpenPaymentConfimation()}
              isLoading={loadingUpdate}
              text={"Konfirmasi"}
            />
          </Box>
        </Box>
      </ModalFC>
    </form>
  );
}
